//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TopNavService } from "@nuskin/ns-product";
import { NsTabs, NsTab, NsTabsItems } from "@nuskin/design-components";

import NsTopnavSection from "./NsTopnavSection.vue";

export default {
  name: "NsTopnav",
  components: {
    NsTabs,
    NsTab,
    NsTabsItems,
    NsTopnavSection
  },
  props: {
    /**
     * Navigation array for the mega dropdown
     */
    localNavigation: {
      type: Array,
      default: null
    },
    /**
     * Allows tabs for mega dropdown to be clickable to top-level category pages
     * Should only be used for dev purposes, as it is incompatible with touch
     * devices
     */
    useTopLevelNav: {
      type: Boolean,
      default: false
    },
    /**
     * Deprecated: THis prop does nothing
     */
    useTopnavService: Boolean
  },
  data: function() {
    return {
      /**
       * Toggles display of the corresponding mega dropdown section
       * -1 unsets display
       */
      navSelected: -1,
      navigationFromService: []
    };
  },
  computed: {
    navigation() {
      return this.localNavigation || this.navigationFromService;
    }
  },
  watch: {
    navSelected: {
      immediate: true,
      handler() {
        document
          .querySelectorAll(".tabItem.iron-selected .tab-column__body")
          // eslint-disable-next-line arrow-parens
          .forEach(column => {
            column.style.width = `${column.scrollWidth}px`;
          });
      }
    }
  },
  mounted: function() {
    this.getNavigation();
  },
  methods: {
    deselectTab() {
      this.navSelected = -1;
    },
    selectTab(index) {
      this.navSelected = index;
    },
    async getNavigation() {
      if (!this.localNavigation) {
        const data = await TopNavService.getTopNavigation();
        this.navigationFromService = data;
      }
    }
  }
};
